export const environment = {
  environment: 'dev02',
  production: false,
  baseUrl: 'https://api-services.dev02.1placedessaisons.com/dev02',
  serviceConfigUrl: 'incidents/v1/pagerDutyServices',
  resourceManagerUrl: 'https://api-services.int.1placedessaisons.com/int/v2/permissions',
  idp: {
    issuer: 'https://api-services.int.1placedessaisons.com/int/v1/oidc',
    clientId: '93147e22-195c-4000-a1eb-6cad2aadce18',
  },
};
